export default import.meta.ROLLDOWN_FILE_URL_6Z9bLhncN5znScBEgEzgkw